import { useQuery } from '@tanstack/react-query'

export const PREVIEW_MODE_KEY = ['preview-mode']

export const usePreviewMode = () => useQuery(PREVIEW_MODE_KEY, () => false).data || false
